import { Input } from "@/components/ui/input";
import { Sparkle } from "@phosphor-icons/react";

const CONF_LABEL = { alta: "confianza alta", media: "confianza media", baja: "confianza baja · verifica" };

// Campos de ficha técnica generados desde el esquema de la categoría.
// `values`/`onChange` los controla el padre (puede mapear cpu/ram/storage a otros campos).
// `aiKeys`/`aiConfidence`: claves llenadas por Alendra AI (se resaltan para revisión).
export default function SpecFields({ fields = [], values = {}, onChange, hideKeys = [], showMissing = false, testidPrefix = "spec", compact = false, columns = "grid-cols-1 sm:grid-cols-2", aiKeys = [], aiConfidence = {} }) {
  const visible = fields.filter((f) => !hideKeys.includes(f.key));
  if (visible.length === 0) return null;
  return (
    <div className={`grid ${columns} gap-2`} data-testid={`${testidPrefix}-fields`}>
      {visible.map((f) => {
        const val = values[f.key] ?? "";
        const missing = showMissing && f.required && !String(val).trim();
        const ai = aiKeys.includes(f.key) && String(val).trim();
        const conf = aiConfidence[f.key];
        const listId = `${testidPrefix}-list-${f.key}`;
        const cls = `${compact ? "h-8 text-sm" : ""} ${missing ? "border-[#E0000F] bg-[#E0000F]/5" : ""} ${ai ? (conf === "baja" ? "border-amber-500 bg-amber-50" : "border-[#7E57C2] bg-[#7E57C2]/5") : ""}`;
        return (
          <div key={f.key} className={f.type === "textarea" ? "sm:col-span-2" : ""}>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-0.5 flex items-center gap-1">
              {f.label}
              {f.required && <span className="text-[#E0000F]" title="Obligatorio para tienda">*</span>}
              {!f.public && <span className="text-zinc-400 normal-case tracking-normal">· interno</span>}
              {ai && (
                <span className={`ml-auto inline-flex items-center gap-0.5 normal-case tracking-normal font-semibold ${conf === "baja" ? "text-amber-600" : "text-[#7E57C2]"}`} title={CONF_LABEL[conf] || "sugerido por Alendra AI"} data-testid={`${testidPrefix}-${f.key}-ai`}>
                  <Sparkle size={10} weight="fill" /> IA{conf ? ` · ${conf}` : ""}
                </span>
              )}
            </div>
            {f.type === "textarea" ? (
              <textarea
                value={val}
                onChange={(e) => onChange(f.key, e.target.value)}
                placeholder={f.placeholder}
                rows={2}
                className={`w-full border border-zinc-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#002FA7] ${cls}`}
                data-testid={`${testidPrefix}-${f.key}`}
              />
            ) : (
              <>
                <Input
                  value={val}
                  onChange={(e) => onChange(f.key, e.target.value)}
                  placeholder={f.placeholder || (f.options?.length ? `Elige o escribe · ej. ${f.options[0]}` : "")}
                  list={f.options?.length ? listId : undefined}
                  autoComplete="off"
                  className={cls}
                  data-testid={`${testidPrefix}-${f.key}`}
                />
                {f.options?.length > 0 && (
                  <datalist id={listId}>
                    {f.options.map((o) => <option key={o} value={o} />)}
                  </datalist>
                )}
              </>
            )}
            {missing && <div className="text-[10px] text-[#E0000F] mt-0.5" data-testid={`${testidPrefix}-${f.key}-missing`}>Obligatorio</div>}
          </div>
        );
      })}
    </div>
  );
}
